import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { AdminAuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor {
  constructor(private readonly auth: AdminAuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(environment.apiUrl)) {
      return next.handle(req);
    }

    return from(this.auth.getIdToken()).pipe(
      switchMap((token) => {
        if (!token) return next.handle(req);
        return next.handle(
          req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
        );
      }),
    );
  }
}
